import React, { Component } from 'react';
import axios from '../../utils/AxiosWrapper';
import moment from 'moment';
import i18n from '../../i18n/i18n';
import './MapsSplit.css';

class MapsSplit extends Component {
    getStatusLabels = () => ({
        1: i18n.t('Finished'),
        2: i18n.t('In progress'),
        3: i18n.t('Open'),
        4: i18n.t('Locked'),
        5: i18n.t('Planned'),
    });

    constructor(props) {
        super(props);
        const initialId = props && props.fieldInfo && props.fieldInfo.details ? props.fieldInfo.details.id : null;

        this.state = {
            activities: [],
            selected: 1,
            idTabla: initialId,
            loadingActivities: false,
            activitiesError: null,
            selectedActivity: null,
            loadingActivityDetails: false,
            selectedActivityDetails: null,
            currencyCode: '',
            showAllFields: false,
            expandedSections: {},
        };
    }

    componentDidMount() {
        this.fetchCurrency();
        const initialId = this.getCurrentTableId();
        if (initialId) {
            this.readActivities(initialId);
        }
    }

    componentDidUpdate(prevProps) {
        const prevId = prevProps && prevProps.fieldInfo && prevProps.fieldInfo.details ? prevProps.fieldInfo.details.id : null;
        const currentId = this.getCurrentTableId();

        if (currentId !== prevId) {
            this.setState(
                {
                    idTabla: currentId || null,
                    activities: [],
                    activitiesError: null,
                    selectedActivity: null,
                    selectedActivityDetails: null,
                    loadingActivityDetails: false,
                    selected: 1,
                    showAllFields: false,
                },
                () => {
                    if (currentId) {
                        this.readActivities(currentId);
                    }
                }
            );
        }
    }

    fetchCurrency = () => {
        axios
            .get('api/valuta/get_valuta_id_naziv')
            .then((response) => {
                const data = response && response.data ? response.data.data : null;
                if (!data) {
                    return;
                }
                const currencyCode = data.valuta_code || data.valuta || '';
                this.setState({ currencyCode });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    getCurrentTableId = () => {
        const { fieldInfo } = this.props;
        return fieldInfo && fieldInfo.details ? fieldInfo.details.id : null;
    };

    handleViewChange = (selected) => {
        if (selected === this.state.selected) {
            return;
        }

        this.setState({ selected }, () => {
            if (selected === 1) {
                const idTabla = this.getCurrentTableId();
                if (idTabla) {
                    this.readActivities(idTabla);
                }
            }
            if (selected !== 2) {
                this.setState({
                    selectedActivity: null,
                    selectedActivityDetails: null,
                    loadingActivityDetails: false,
                });
            }
        });
    };

    readActivities = (idTabla) => {
        if (!idTabla) {
            return;
        }

        this.setState({ loadingActivities: true, activitiesError: null });
        axios
            .get('api/activity/readBasicInfo', { params: { id_tabla: idTabla } })
            .then((response) => {
                const data = Array.isArray(response.data) ? response.data : [];
                this.setState({ activities: data, loadingActivities: false });
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loadingActivities: false,
                    activitiesError: 'Greska pri preuzimanju radnih naloga.',
                });
            });
    };

    safeArray = (value) => (Array.isArray(value) ? value : []);

    formatDate = (value) => {
        if (!value) return '-';
        const date = moment(value);
        return date.isValid() ? date.format('DD.MM.YYYY') : value;
    };

    formatArea = (value) => {
        if (value === null || value === undefined) return '-';
        const num = Number(value);
        return Number.isFinite(num) ? `${this.formatDecimal(num, 2)} ha` : value;
    };

    formatNumber = (value) => {
        if (value === null || value === undefined || value === '') return null;
        const num = Number(value);
        if (!Number.isFinite(num)) {
            return typeof value === 'string' ? value : null;
        }
        const decimals = Math.abs(num % 1) < 0.005 ? 0 : 2;
        return this.formatDecimal(num, decimals);
    };

    formatDecimal = (value, decimals = 2) => {
        if (!Number.isFinite(value)) return null;
        try {
            return value.toLocaleString('en-US', {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals,
            });
        } catch (e) {
            return value.toFixed(decimals);
        }
    };

    formatCurrency = (value) => {
        if (value === null || value === undefined || value === '') {
            return '-';
        }
        const num = Number(value);
        if (!Number.isFinite(num)) {
            return '-';
        }
        const currencyCode = this.state.currencyCode || 'RSD';
        const formatted = this.formatDecimal(num, 2);
        return `${formatted} ${currencyCode}`;
    };

    calculateLineTotal = (quantity, price) => {
        const usage = Number(quantity);
        const unitPrice = Number(price);
        if (!Number.isFinite(usage) || !Number.isFinite(unitPrice)) {
            return null;
        }
        return usage * unitPrice;
    };

    getOperationIcon = () => <img src="./production.svg" height="26" alt="" aria-hidden="true" color="#0b6b47" />;

    getOperationName = (...candidates) => {
        for (const candidate of candidates) {
            if (!candidate) continue;
            if (candidate.radna_operacija && candidate.radna_operacija.naziv) {
                return candidate.radna_operacija.naziv;
            }
            if (candidate.radna_operacija_naziv) {
                return candidate.radna_operacija_naziv;
            }
            if (candidate.naziv) {
                return candidate.naziv;
            }
        }
        return 'Radni nalog';
    };

    extractStatusId = (statusLike) => {
        if (statusLike === null || statusLike === undefined) return null;
        if (typeof statusLike === 'number') return statusLike;
        if (typeof statusLike === 'string') {
            const parsed = parseInt(statusLike, 10);
            if (!Number.isNaN(parsed)) {
                return parsed;
            }
        }
        if (typeof statusLike === 'object') {
            if (statusLike.id_status) return statusLike.id_status;
            if (statusLike.id) return statusLike.id;
        }
        return null;
    };

    extractStatusName = (statusLike) => {
        if (!statusLike) return '';
        if (typeof statusLike === 'string') return statusLike;
        if (typeof statusLike === 'object') {
            return statusLike.naziv || statusLike.label || statusLike.status || '';
        }
        return '';
    };

    getStatusModifier = (statusLike) => {
        const id = this.extractStatusId(statusLike);
        if (id === 2) return 'in-progress';
        if (id === 1) return 'done';
        switch (id) {
            case 4:
            case 5:
            case 3:
                return 'default';
            default:
                break;
        }

        const normalized = this.extractStatusName(statusLike).toLowerCase();
        if (normalized.includes('tok') || normalized.includes('progress')) return 'in-progress';
        if (normalized.includes('zavr') || normalized.includes('complete')) return 'done';
        return 'default';
    };

    renderStatusLabel = (statusLike) => {
        const id = this.extractStatusId(statusLike);
        const statusLabels = this.getStatusLabels();
        if (id && statusLabels[id]) {
            return statusLabels[id];
        }
        const normalized = this.extractStatusName(statusLike);
        if (normalized) {
            return normalized;
        }
        return i18n.t('Status unknown');
    };

    generateColoredCircle = () => <span className="maps-split-status-indicator" aria-hidden="true" />;

    getActivityFields = (...sources) => {
        const unique = [];
        const seen = new Set();

        sources.forEach((source) => {
            if (!source) return;
            const arrays = [];
            if (Array.isArray(source)) {
                arrays.push(source);
            } else {
                if (Array.isArray(source.tables)) arrays.push(source.tables);
                if (Array.isArray(source.table)) arrays.push(source.table);
            }

            arrays.forEach((arr) => {
                arr.forEach((item) => {
                    if (!item) return;
                    const tabla = item.tabla || item;
                    const id = tabla.id || item.id_tabla || item.id;
                    const name = tabla.naziv || item.naziv;
                    if (!name) return;
                    const key = id || name;
                    if (seen.has(key)) return;
                    seen.add(key);
                    unique.push({ id: key, naziv: name });
                });
            });
        });

        return unique;
    };

    toggleSection = (sectionKey) => {
        this.setState((prev) => ({
            expandedSections: {
                ...prev.expandedSections,
                [sectionKey]: !prev.expandedSections[sectionKey],
            },
        }));
    };

    renderInfoSection = (title, icon, items, emptyText, renderItem) => {
        const isExpanded = !!this.state.expandedSections[title];
        const visibleItems = items.length > 3 && !isExpanded ? items.slice(0, 3) : items;

        return (
            <div className="maps-split-info-section">
                <div className="maps-split-info-section-header">
                    {icon && <span className="maps-split-section-icon" aria-hidden="true">{icon}</span>}
                    <div className="maps-split-section-title">{title}</div>
                </div>
                {items.length ? (
                    <>
                        <ul className="maps-split-info-list">
                            {visibleItems.map((item, index) => (
                                <li key={`${title}-${index}`} className="maps-split-info-list-item">
                                    {renderItem(item)}
                                </li>
                            ))}
                        </ul>
                        {items.length > 3 && (
                            <button
                                type="button"
                                className="maps-split-field-chip maps-split-field-chip--more"
                                style={{ alignSelf: 'flex-start', marginTop: '4px' }}
                                onClick={() => this.toggleSection(title)}
                            >
                                {isExpanded ? i18n.t('Show less') : `...${i18n.t('Show more')} (${items.length})`}
                            </button>
                        )}
                    </>
                ) : (
                    <div className="maps-split-info-empty">{emptyText}</div>
                )}
            </div>
        );
    }

    getMaterialsSectionIcon = () => (
        <span className="icon-Material menuIcon" aria-hidden="true" style={{ color: '#0b6b47', paddingLeft: '22px'}} />
    );

    getYieldsSectionIcon = () => (
        <span className="icon-Biljka menuIcon" aria-hidden="true" style={{ color: '#0b6b47', paddingLeft: '22px' }} />
    );

    getMachinesSectionIcon = () => (
        <span className="icon-Machines menuIcon" aria-hidden="true" style={{ color: '#0b6b47', paddingLeft: '22px' }} />
    );

    getImplementsSectionIcon = () => (
        <span className="icon-Implements menuIcon" aria-hidden="true" style={{ color: '#0b6b47', paddingLeft: '22px' }} />
    );

    renderMaterialsSection = (items, config = {}) => {
        const {
            title = i18n.t('Materials'),
            icon = this.getMaterialsSectionIcon(),
            nameLabel = i18n.t('Material'),
            amountLabel = i18n.t('Used'),
            priceLabel = i18n.t('Price per unit'),
            totalColumnLabel = i18n.t('Total'),
            emptyText = i18n.t('No materials recorded for this work order.'),
            totalLabel = i18n.t('Total used'),
            amountKey = 'utroseno',
        } = config;

        const hasItems = Array.isArray(items) && items.length > 0;
        const totalCost = hasItems
            ? items.reduce((sum, item) => {
                  const rowTotal = this.calculateLineTotal(item[amountKey], item.cena_po_jm);
                  return rowTotal === null ? sum : sum + rowTotal;
              }, 0)
            : 0;

        return (
            <div className="maps-split-info-section maps-split-materials-section">
                <div className="maps-split-info-section-header">
                    <span className="maps-split-section-icon" aria-hidden="true">
                        {icon}
                    </span>
                    <div className="maps-split-section-title">{title}</div>
                </div>
                {hasItems ? (
                    <>
                        <div className="maps-split-materials-table-wrapper">
                            <table className="maps-split-materials-table">
                                <thead>
                                    <tr>
                                        <th>{nameLabel}</th>
                                        <th>{amountLabel}</th>
                                        <th>{priceLabel}</th>
                                        <th>{totalColumnLabel}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((item, index) => {
                                        const amountValue = this.formatNumber(item[amountKey]);
                                        const unit = item.jedinica_mere ? ` ${item.jedinica_mere}` : '';
                                        const totalValue = this.calculateLineTotal(item[amountKey], item.cena_po_jm);
                                        return (
                                            <tr key={`${title}-${item.id || index}`}>
                                                <td>{item.naziv || '-'}</td>
                                                <td>{amountValue ? `${amountValue}${unit}` : '-'}</td>
                                                <td>{this.formatCurrency(item.cena_po_jm)}</td>
                                                <td>{this.formatCurrency(totalValue)}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className="maps-split-materials-total">
                            {totalLabel}: {this.formatCurrency(totalCost)}
                        </div>
                    </>
                ) : (
                    <div className="maps-split-info-empty">{emptyText}</div>
                )}
            </div>
        );
    };

    renderYieldSection = (yields) => {
        if (!yields || yields.length === 0) return null;
        return this.renderMaterialsSection(yields, {
            title: i18n.t('Yields'),
            icon: this.getYieldsSectionIcon(),
            nameLabel: i18n.t('Yield'),
            amountLabel: i18n.t('Quantity'),
            emptyText: i18n.t('No yields recorded for this work order.'),
            totalLabel: i18n.t('Total achieved'),
            amountKey: 'prinos',
        });
    };

    renderMachineItem = (machine) => {
        const base = machine.pogonska || machine;
        const name = base && (base.pogonska_naziv || base.naziv) ? (base.pogonska_naziv || base.naziv) : machine.naziv;
        const plate = base && base.registarska_oznaka ? base.registarska_oznaka : machine.registarska_oznaka;
        const icon = this.getMachinesSectionIcon();

        return (
            <div className="maps-split-info-entry">
                <div>
                    <div className="maps-split-info-item-title">{name || 'Pogonska masina'}</div>
                    {plate && <div className="maps-split-info-item-subtitle">{plate}</div>}
                </div>
            </div>
        );
    };

    renderImplementItem = (implement) => {
        const base = implement.prikljucna || implement;
        const name = base && base.naziv ? base.naziv : implement.naziv;
        const icon = this.getImplementsSectionIcon();

        return (
            <div className="maps-split-info-entry">

                <div>
                    <div className="maps-split-info-item-title">{name || 'Prikljucna masina'}</div>
                    {implement.napomena && <div className="maps-split-info-item-subtitle">{implement.napomena}</div>}
                </div>
            </div>
        );
    };
    handleActivitySelect = (activity) => {
        if (!activity) {
            return;
        }
        this.setState(
            {
                selectedActivity: activity,
                selectedActivityDetails: null,
                loadingActivityDetails: true,
                selected: 2,
                showAllFields: false,
            },
            () => {
                axios
                    .get('api/activity/getById', { params: { id: activity.id } })
                    .then((res) => {
                        this.setState({
                            selectedActivityDetails: res.data.data,
                            loadingActivityDetails: false,
                        });
                    })
                    .catch(() => {
                        this.setState({ loadingActivityDetails: false });
                    });
            }
        );
    };

    renderActivitiesSection = () => {
        const { activities, loadingActivities, activitiesError } = this.state;

        if (loadingActivities) {
            return <div className="maps-split-message">Učitavanje radnih naloga...</div>;
        }

        if (activitiesError) {
            return <div className="maps-split-message maps-split-message--error">{activitiesError}</div>;
        }

        if (!activities || activities.length === 0) {
            return <div className="maps-split-message">Nema evidentiranih radnih naloga za ovu proizvodnu tablu.</div>;
        }

        return (
            <div className="maps-split-activity-list">
                {activities.map((activity, idx) => {
                    const title = this.getOperationName(activity);
                    const fields = this.getActivityFields(activity);
                    const statusValue = activity.id_status || activity.status;
                    const statusModifier = this.getStatusModifier(statusValue);
                    return (
                        <div
                            key={activity.id || idx}
                            className="maps-split-activity-card"
                            role="button"
                            tabIndex={0}
                            onClick={() => this.handleActivitySelect(activity)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    this.handleActivitySelect(activity);
                                }
                            }}
                        >
                            <div className="maps-split-card-header">
                                <div className="maps-split-activity-title-row">
                                    <span className="maps-split-activity-icon">{this.getOperationIcon()}</span>
                                    <div className="maps-split-activity-title">{title}</div>
                                </div>
                                <div className="maps-split-cell--status">
                                    <div className={`maps-split-status maps-split-status--${statusModifier}`}>
                                        {this.generateColoredCircle(statusValue)}
                                        <span className="maps-split-status-label">
                                            {this.renderStatusLabel(statusValue)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="maps-split-card-body">
                                <span className="maps-split-date-primary">
                                    {i18n.t('Start')}: {this.formatDate(activity.datum_pocetka)}
                                </span>
                                {activity.datum_zavrsetka && (
                                    <span className="maps-split-date-secondary">
                                        {i18n.t('End')}: {this.formatDate(activity.datum_zavrsetka)}
                                    </span>
                                )}
                            </div>
                            {fields.length > 0 && (
                                <div className="maps-split-fields-inline">
                                    {fields.length <= 3
                                        ? `${i18n.t('Fields')}: ${fields.map((field) => field.naziv).join(', ')}`
                                        : `${i18n.t('Fields')} (${fields.length}): ${fields.slice(0, 3).map((field) => field.naziv).join(', ')}  ...`
                                    }
                                </div>
                            )}
                            {activity.komentar && (
                                <div className="maps-split-activity-description">  {i18n.t('Comment')}: {activity.komentar}</div>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    };

    renderActivityDetails = () => {
        const { selectedActivity, selectedActivityDetails, loadingActivityDetails } = this.state;

        if (!selectedActivity) {
            return (
                <div className="maps-split-message">
                    Izaberite radni nalog iz liste kako biste videli detaljnije informacije.
                </div>
            );
        }

        const mergedActivity = {
            ...(selectedActivity || {}),
            ...(selectedActivityDetails || {}),
        };

        const statusValue =
            mergedActivity.id_status || (mergedActivity.status && mergedActivity.status.id) || mergedActivity.status;
        const statusModifier = this.getStatusModifier(statusValue);
        const startDate = this.formatDate(mergedActivity.datum_pocetka);
        const endDate = mergedActivity.datum_zavrsetka ? this.formatDate(mergedActivity.datum_zavrsetka) : null;
        const fields = this.getActivityFields(selectedActivity, selectedActivityDetails);
        const allMaterials = this.safeArray(selectedActivityDetails && selectedActivityDetails.materijali);
        const isYieldMaterial = (item) => {
            if (!item) return false;
            if (item.indikator_prinosa === true) {
                return true;
            }
            return Number(item.indikator_prinosa) === 1;
        };
        const materials = allMaterials.filter((item) => !isYieldMaterial(item));
        const yields = allMaterials.filter((item) => isYieldMaterial(item));
        const machines = this.safeArray(selectedActivityDetails && selectedActivityDetails.pogonskeMasine);
        const implementsList = this.safeArray(selectedActivityDetails && selectedActivityDetails.prikljucneMasine);

        const noteValue = mergedActivity.napomena || mergedActivity.napomena_unutrasnja || '-';
        const commentValue = mergedActivity.komentar || '-';

        return (
            <div className="maps-split-details">
                <div className="maps-split-details-card">
                    <div className="maps-split-details-header">
                        <div>
                            <div className="maps-split-activity-title-row">
                                <span className="maps-split-activity-icon">{this.getOperationIcon()}</span>
                                <div className="maps-split-details-main-title">
                                    {this.getOperationName(selectedActivityDetails, selectedActivity)}
                                </div>
                            </div>
                            <div className="maps-split-details-subtitle">
                                {endDate ? `${startDate} - ${endDate}` : startDate}
                            </div>
                            {fields.length > 0 && (
                                <div className="maps-split-details-caption">
                                    {fields.length === 1
                                        ? i18n.t('1 field in work order')
                                        : i18n.t('{{count}} fields in work order', { count: fields.length })}
                                </div>
                            )}
                        </div>
                        <div className={`maps-split-status maps-split-status--${statusModifier}`}>
                            {this.generateColoredCircle(statusValue)}
                            <span className="maps-split-status-label">
                                {this.renderStatusLabel(
                                    statusValue || (mergedActivity.status && mergedActivity.status.naziv)
                                )}
                            </span>
                        </div>
                    </div>

                    {fields.length > 0 && (
                        <div className="maps-split-field-chips">
                            {(this.state.showAllFields ? fields : fields.slice(0, 3)).map((field) => (
                                <span key={field.id || field.naziv} className="maps-split-field-chip">
                                    {field.naziv}
                                </span>
                            ))}
                            {fields.length > 3 && !this.state.showAllFields && (
                                <button
                                    type="button"
                                    className="maps-split-field-chip maps-split-field-chip--more"
                                    onClick={() => this.setState({ showAllFields: true })}
                                >
                                    ...{i18n.t('Show more')}
                                </button>
                            )}
                            {fields.length > 3 && this.state.showAllFields && (
                                <button
                                    type="button"
                                    className="maps-split-field-chip maps-split-field-chip--more"
                                    onClick={() => this.setState({ showAllFields: false })}
                                >
                                    {i18n.t('Show less')}
                                </button>
                            )}
                        </div>
                    )}

                    {loadingActivityDetails && !selectedActivityDetails && (
                        <div className="maps-split-message maps-split-message--muted">
                            Ucitavanje dodatnih informacija...
                        </div>
                    )}
                </div>


                {this.renderMaterialsSection(materials)}

                {this.renderYieldSection(yields)}

                {this.renderInfoSection(
                    i18n.t('Power machines'),
                    this.getMachinesSectionIcon(),
                    machines,
                    i18n.t('No machines added.'),
                    this.renderMachineItem
                )}

                {this.renderInfoSection(
                    i18n.t('Attached equipment'),
                    this.getImplementsSectionIcon(),
                    implementsList,
                    i18n.t('No attachments added.'),
                    this.renderImplementItem
                )}

                {/* <div className="maps-split-info-section">
                    <div className="maps-split-info-section-header">
                        <div className="maps-split-section-title">{i18n.t('Remark')}</div>
                    </div>
                    <div className="maps-split-info-empty">{noteValue}</div>
                </div> */}

                <div className="maps-split-info-section">
                    <div className="maps-split-info-section-header">
                        <div className="maps-split-section-title">{i18n.t('Comment')}</div>
                    </div>
                    <div className="maps-split-info-empty">{commentValue}</div>
                </div>

                <button type="button" className="maps-split-back-button" onClick={() => this.handleViewChange(1)}>
                    <span className="maps-split-back-icon" aria-hidden="true">⟵</span>
                    {i18n.t('Back to work order list')}
                </button>
            </div>
        );
    };

    getSummaryItems = (info) => [
        { label: i18n.t('Field name'), value: info.naziv || '-' },
        { label: i18n.t('Culture'), value: info.kultura_naziv || info.kultura || '-' },
        { label: i18n.t('Crop varieties'), value: info.sorta_naziv || '-' },
        // { label: i18n.t('Group'), value: info.kultura_grupa_naziv || '-' },
        // { label: i18n.t('Subgroup'), value: info.kultura_podgrupa_naziv || '-' },
        { label: i18n.t('Area'), value: this.formatArea(info.povrsina) },
    ];

    renderSelectedView = (info) => {
        const { selected } = this.state;

        if (selected === 1) {
            return (
                <div>
                    <div className="maps-split-section-title">{i18n.t('Activities')}</div>
                    <div className="maps-split-section-subtitle">{i18n.t('Operations related to the selected field.')}</div>
                    {this.renderActivitiesSection()}
                </div>
            );
        }

        if (selected === 2) {
            return this.renderActivityDetails();
        }

        return (
            <div className="maps-split-summary-grid">
                {this.getSummaryItems(info).map((item) => (
                    <div key={item.label} className="maps-split-summary-card">
                        <div className="maps-split-summary-label">{item.label}</div>
                        <div className="maps-split-summary-value">{item.value}</div>
                    </div>
                ))}
            </div>
        );
    };

    render() {
        const { fieldInfo, onClose } = this.props;
        const info = fieldInfo && fieldInfo.details ? fieldInfo.details : {};

        const viewOptions = [
            {
                id: 1,
                label: i18n.t('Work orders'),
                icon: (
                    <span
                        className="icon-NoviRadniNalog menuIcon"
                        style={{ color: '#0b6b47', paddingRight: '2px' }}
                        aria-hidden="true"
                    />
                ),
            },
            {
                id: 0,
                label: i18n.t('Field overview'),
                icon: (
                    <span
                        className="icon-Fields menuIcon"
                        style={{ color: '#0b6b47', paddingRight: '2px' }}
                        aria-hidden="true"
                    />
                ),
            },
        ];

        return (
            <div className="maps-split-wrapper">
                <div className="maps-split-header">
                    <div className="maps-split-header-info">
                        <div className="maps-split-header-title">
                            {i18n.t('Field name')}:{' '}
                            <span className="maps-split-header-emphasis">{info.naziv || i18n.t('No name')}</span>
                        </div>
                        <div className="maps-split-header-subtitle">
                            {i18n.t('Culture name')}:{' '}
                            <span className="maps-split-subtitle-strong">
                                {info.kultura_naziv || info.kultura || i18n.t('No name')}
                            </span>
                        </div>
                    </div>
                    <button type="button" className="maps-split-close" title={i18n.t('Close')} onClick={onClose}>
                        &#10005;
                    </button>
                </div>

                <div className="maps-split-view-options">
                    {viewOptions.map((option) => {
                        const isActive = option.id === this.state.selected;
                        return (
                            <button
                                key={option.id}
                                type="button"
                                onClick={() => this.handleViewChange(option.id)}
                                className={`maps-split-view-button${isActive ? ' active' : ''}`}
                            >
                                {option.icon}
                                <span className="maps-split-view-label">{option.label}</span>
                            </button>
                        );
                    })}
                </div>

                {this.renderSelectedView(info)}
            </div>
        );
    }
}

export default MapsSplit;


